import * as React from 'react';
import { injectIntl, WrappedComponentProps as InjectedIntlProps } from 'react-intl';
import { Button, Input } from 'semantic-ui-react';

import { formatMessageHelper, FormattedMessageHelper } from '../../../shared/helpers/internationalization';

interface RenameListProps {
  handleRenameList: () => void;
  handleChangeInput: (e: any, data: any) => void;
  listName: string;
}

export const RenameList = injectIntl(({ handleRenameList, handleChangeInput, listName, intl }: RenameListProps & InjectedIntlProps) => (
  <React.Fragment>
    <header className="modal__header">
      <h3 className="modal__title">
        <FormattedMessageHelper id="alphasMain.cardRightElemHeader.renameList" />
      </h3>
    </header>
    <div className="rename-list">
      <Input
        className="rename-list__input"
        focus={true}
        placeholder={formatMessageHelper(intl, 'alphasMain.renameList.placeHolderNameNewList')}
        value={listName}
        onChange={handleChangeInput}
        name="newList"
      />
      <Button className="form__button rename-list__button" onClick={handleRenameList} primary={true}>
        <FormattedMessageHelper id="alphasComparisonMain.renameList.submitNewName" />
      </Button>
    </div>
  </React.Fragment>
));
